import { message } from 'antd';
import { createApi } from '@reduxjs/toolkit/query/react';
import qs from 'qs';
import fetch from 'auth/FetchInterceptor';
import baseQueryWith409 from './baseQueryWith409';

// direct fetch without RTK Query
export const getCarreras = query =>
	fetch.get(
		`/carreras${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const getCarrera = ({ id, query }) =>
	fetch.get(
		`/carreras/${id}${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const addCarrera = data => fetch.post('/carreras', data);
export const updateCarrera = ({ id, ...data }) =>
	fetch.put(`/carreras/${id}`, data);
export const deleteCarrera = id => fetch.delete(`/carreras/${id}`);

// RTK Query
export const carrerasApi = createApi({
	reducerPath: 'carrerasApi',
	baseQuery: baseQueryWith409,

	// default configuration
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: true,
	refetchOnFocus: true,

	//endpoints
	endpoints: build => ({
		getCarreras: build.query({
			query: query => {
				return {
					url: `/carreras${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: result =>
				// is result available?
				result
					? // successful query
					  [
							...result.map(({ id }) => ({ type: 'Carreras', id })),
							{ type: 'Carreras', id: 'LIST' },
					  ]
					: // an error occurred, but we still want to refetch this query when `{ type: 'Posts', id: 'LIST' }` is invalidated
					  [{ type: 'Carreras', id: 'LIST' }],
		}),
		getCarrera: build.query({
			query: ({ id, query }) => {
				return {
					url: `/carreras/${id}${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: (result, error, id) => [{ type: 'Carreras', id }],
		}),
		addCarrera: build.mutation({
			query: data => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/carreras`,
					method: 'POST',
					body: JSON.stringify({
						data: {
							...data,
							created_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Carrera agregado exitosamente');
				} catch (error) {
					message.error('Error al agregar carrera');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: [{ type: 'Carreras', id: 'LIST' }],
		}),
		updateCarrera: build.mutation({
			query: ({ id, ...data }) => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/carreras/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							...data,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Carrera actualizado exitosamente');
				} catch (error) {
					message.error('Error al actualizar carrera');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, { id }) => [{ type: 'Carreras', id }],
		}),
		deleteCarrera: build.mutation({
			query: id => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/carreras/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							publishedAt: null,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Carrera eliminado exitosamente');
				} catch (error) {
					message.error('Error al eliminar carrera');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, id) => [{ type: 'Carreras', id }],
		}),
	}),
});

export const {
	useGetCarrerasQuery,
	useGetCarreraQuery,
	useAddCarreraMutation,
	useUpdateCarreraMutation,
	useDeleteCarreraMutation,
} = carrerasApi;
